import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { SlideLayout, itemVariants } from '../ui/SlideLayout';
const team = [{
  name: 'Nour de Vos',
  initials: 'NV',
  role: 'CEO',
  bio: "Managed $1B+ assets by 28, mined 25% of Bittensor's FDV ($200M) via GPU mining innovation, and founded 4 startups including bittensor.exchange (sold) and an NFT DEX with $700M peak volume.",
  linkedin: 'https://www.linkedin.com/in/nour-de-vos-61963034/',
  photo: 'https://cdn.magicpatterns.com/uploads/nDieQJyjj4AmMnK5emAoAz/Nour_bio_photo.png',
  badges: [{
    label: 'Hardware Synthesis'
  }, {
    label: 'LLM Optimization'
  }]
}, {
  name: 'Orion Parrott',
  initials: 'OP',
  role: 'CTO',
  bio: 'YC alum (S16), Founding GP of orangedao.xyz, the community of YC-backed founders. Deployed $26M into 200 web3 startups, achieving 2.2X MOIC at Y3. MBA, MSEE with patent for a portable scalable signal processor.',
  linkedin: 'https://linkedin.com/in/orionparrott',
  photo: 'https://cdn.magicpatterns.com/uploads/nwg3QKiFH4KnJ983THFeR9/OP_sq.jpg',
  badges: [{
    label: 'Raytheon'
  }, {
    label: 'UC Berkeley'
  }, {
    label: 'Y Combinator S16'
  }, {
    label: 'Orange DAO'
  }]
}, {
  name: 'Faris Oweis',
  initials: 'FO',
  role: 'Head of Business Development',
  bio: 'Growth and revenue leader in crypto and AI who has driven over $100M in TVL, helped clients raise $120M from top investors, and managed liquidity providers with more than $2B in assets.',
  linkedin: 'https://www.linkedin.com/in/farisoweis/',
  photo: 'https://cdn.magicpatterns.com/uploads/7Z2W4wrjgfCDhtaXmdS2gV/faris_bio_photo.jpg',
  badges: [{
    label: 'GTM Strategy'
  }, {
    label: 'Partnerships'
  }]
}];
function ProfilePhoto({
  src,
  initials
}: {
  src: string;
  initials: string;
}) {
  const [failed, setFailed] = useState(false);
  return <div className="w-24 h-24 rounded-full border-2 border-brand-teal bg-brand-bg flex items-center justify-center mb-6 shadow-[0_0_15px_rgba(0,212,170,0.2)] overflow-hidden" data-id="element-454">
      {!failed ? <img src={src} alt="" className="w-full h-full object-cover" onError={() => setFailed(true)} referrerPolicy="no-referrer" data-id="element-455" /> : <span className="text-2xl font-bold text-brand-text" data-id="element-456">{initials}</span>}
    </div>;
}
export function TeamSlide() {
  return <SlideLayout data-id="element-457">
      <motion.div variants={itemVariants} className="mb-16 text-center" data-id="element-458">
        <h2 className="text-4xl md:text-5xl font-bold text-brand-text mb-4" data-id="element-459">
          Deep FPGA Expertise Meets Startup Execution
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-460">
        {team.map(member => <motion.div key={member.name} variants={itemVariants} className="bg-brand-bg-card border border-brand-border rounded-2xl p-8 flex flex-col items-center text-center" data-id="element-461">
            <ProfilePhoto src={member.photo} initials={member.initials} data-id="element-462" />

            <a href={member.linkedin} target="_blank" rel="noopener noreferrer" className="group flex items-center gap-2 hover:text-brand-teal transition-colors" data-id="element-463">
              <h3 className="text-2xl font-bold text-brand-text group-hover:text-brand-teal transition-colors" data-id="element-464">
                {member.name}
              </h3>
              <svg className="w-5 h-5 flex-shrink-0" viewBox="0 0 24 24" fill="currentColor" data-id="element-465">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" data-id="element-466" />
              </svg>
            </a>

            <p className="text-brand-teal font-medium mb-4 mt-1" data-id="element-467">
              {member.role}
            </p>

            <p className="text-sm text-brand-text-dim mb-6 flex-1" data-id="element-468">
              {member.bio}
            </p>

            <div className="flex flex-wrap justify-center gap-2 mt-auto" data-id="element-469">
              {member.badges.map(badge => <span key={badge.label} className={badge.accent ? 'px-2 py-1 bg-[#ff6600]/10 rounded border border-[#ff6600]/30 text-xs text-[#ff6600]' : 'px-2 py-1 bg-brand-bg rounded border border-brand-border text-xs text-brand-text-muted'} data-id="element-470">
                  {badge.label}
                </span>)}
            </div>
          </motion.div>)}
      </div>
    </SlideLayout>;
}